import { GiBrokenShield, GiCorkedTube, GiCrackedShield } from "react-icons/gi";
import { PiUserCircleCheckFill } from "react-icons/pi";
import { BsShieldFillExclamation, BsInfoCircleFill, BsFillBoxSeamFill } from "react-icons/bs";
import { VscShield } from "react-icons/vsc";
import { IoLeafSharp } from "react-icons/io5";
import { FaRegSquareCheck } from "react-icons/fa6";
import { GrDocumentText } from "react-icons/gr";
import { TiDocumentText } from "react-icons/ti";
export const AggrigadeView = ({ handleChange }) => {
  const tiles = [
    { tile: <BsShieldFillExclamation />, label: "Safety information" },
    { tile: <GiCorkedTube />, label: "Formulation" },
    { tile: <PiUserCircleCheckFill />, label: "Authorisation" },
    { tile: <VscShield />, label: "Additional safety precautions" },
    { tile: <FaRegSquareCheck />, label: "Directions for use" },
    { tile: <IoLeafSharp />, label: "Restrictions" },
    { tile: <GiBrokenShield />, label: "Resistance information" },
    { tile: <BsFillBoxSeamFill />, label: "Transport, storage & disposal" },
    { tile: <BsInfoCircleFill />, label: "Advisory information" },
    { tile: <TiDocumentText />, label: "Front page" },
    { tile: <GrDocumentText />, label: "Full page" }
  ];

  return (
    <div className="mt-2 container rounded-2 border border-2 border-gray p-3">
      <div className="row g-3 justify-content-center">
        {tiles.map((item, index) => (
          <div key={index} className="col-6 col-md-4 col-lg-4 d-flex">
            <div
              className="card w-100 shadow-sm border border-success-subtle bg-success bg-opacity-10"
              role="button"
              tabIndex={0}
              onClick={() => handleChange(item.label)}
            >
              <div className="card-body d-flex flex-column align-items-center text-center">
                {item.tile && (
                  <div className="fw-semibold fs-4 text-muted text-uppercase">
                    {item.tile}
                  </div>
                )}
                <div className="d-flex flex-fill justify-content-center my-2 align-items-center">
                  <span className="fw-semibold lh-sm">{item.label}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

  );
};
